import { IClientAnnex } from './client-annex.interface';
import { IClientCertificate } from './client-certificate.interface';

export enum ClientStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface IClient {
  id: string;
  created_at: string;
  name: string;
  description: string;
  status: ClientStatus;
  cui: string;
  raf_number: string;
  address: string;
  company_id: string;
  certificate?: IClientCertificate;
  annex?: IClientAnnex;
}

export interface IClientDTO {
  id: string;
  name: string;
  description: string;
  status: ClientStatus;
  cui: string;
  raf_number: string;
  address: string;
  company_id: string;
}
